// @flow
// Re-export from new modular structure for backwards compatibility
export {
  track,
  trackPageView,
  resetSession,
  setTag,
  identifyUser,
  upgradeSession,
  TRACKING_EVENTS,
} from './tracking/index';



// WEBPACK FOOTER //
// ./src/lib/tracking.js